<template>
  <div class="container">
    <div class="row">
      <div class="overviewAndNav mb-1">
        <h3>Overzicht E-mails</h3>
        <span>
          <select class="form-select mr-2" v-model="emailFiltering">
            <option :key="mode" v-for="mode in getFilterModes()">{{ mode }}</option>
          </select>
          <button v-if="!showCreateEmail" class="btn-basic btn-fill-pulse" @click="toggleCreateEmail">Nieuw</button>
          <button v-if="showCreateEmail" class="btn-basic btn-fill-pulse-dark" @click="toggleCreateEmail">Annuleren</button>
        </span>
      </div>
    </div>
    <div class="row my-2">
      <input ref="focusMe" type="text" class="form-control" placeholder="Zoeken op e-mail .." v-model="search"/>
    </div>
    <div class="row" v-show="showCreateEmail">
      <CreateConfirmedEmailComponent id="createEmail" @emailAdded="emailAdded"/>
    </div>
    <div class="row">
      <div class="table-responsive">
        <table class="table table-bordered">
          <thead class="thead-dark">
          <tr>
            <SortableTableHeaderComponent columnName="emailAddress" :sortColumn="currentSortColumn"
                :sortDirectionAscending="currentSortDirectionAscending" :sortFunction="sort" text="E-mail"/>
            <SortableTableHeaderComponent columnName="confirmed" :sortColumn="currentSortColumn"
                :sortDirectionAscending="currentSortDirectionAscending" :sortFunction="sort" text="Bevestigd?"/>
            <th scope="col">Actie</th>
          </tr>
          </thead>
          <template v-for="(email) in sortedUsers">
            <tr :key="email.emailAddress">
              <td>{{ email.emailAddress }}</td>
              <td>{{ email.confirmed }}</td>
              <td>
                <button v-if="!email.confirmed" class="btn-basic btn-outline-pulse" :disabled="email.confirmed" @click="confirm(email)">
                  Bevestig e-mail
                </button>
                <button v-else class="btn-basic btn-outline-pulse w-auto" :disabled="email.confirmed" @click="confirm(email)">
                  E-mail reeds bevestigd
                </button>
              </td>
            </tr>
          </template>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import {mapActions, mapGetters, mapMutations} from "vuex";
import FilterModes, {ConfirmedEmailStatusList} from "@/constants/FilterConstants";
import SortableTableHeaderComponent from "@/components/tables/SortableTableHeader";
import {sortListByColumnAndDirection} from "@/util/SortingUtil";
import CreateConfirmedEmailComponent from "@/Admin/CreateConfirmedEmailComponent/CreateConfirmedEmailComponent.vue";

export default {
  name: "AdminConfirmedEmailOverview",
  components: {
    CreateConfirmedEmailComponent,
    SortableTableHeaderComponent,
  },
  data: () => ({
    emailFiltering: FilterModes.ALL,
    currentSortColumn: "emailAddress",
    currentSortDirectionAscending: true,
    search: '',
    showCreateEmail: false,
  }),
  computed: {
    ...mapGetters({
      confirmedEmails: 'confirmedEmail/confirmedEmails',
    }),
    sortedUsers: function () {
      let sortedList = sortListByColumnAndDirection(this.filteredEmails(), this.currentSortColumn, this.currentSortDirectionAscending);
      return sortedList.filter(email => {
        return email.emailAddress.toLowerCase().includes(this.search.toLowerCase());
      });
    },
  },
  mounted() {
    this.$refs.focusMe.focus();
  },
  async created() {
    await this.fetchAllConfirmedEmails();
  },
  methods: {
    ...mapMutations('confirmedEmail', ['setSelectedConfirmedEmail', 'updateSelectedConfirmedEmail']),
    ...mapActions('confirmedEmail', ['fetchAllConfirmedEmails', 'updateConfirmedEmail']),
    showDetailed: function (email) {
      this.setSelectedConfirmedEmail(email);
    },
    toggleCreateEmail() {
      this.showCreateEmail = !this.showCreateEmail;
    },
    emailAdded() {
      this.toggleCreateEmail();
    },
    getFilterModes() {
      return ConfirmedEmailStatusList;
    },
    sort: function (newSortColumn) {
      if (newSortColumn === this.currentSortColumn) {
        this.currentSortDirectionAscending = !this.currentSortDirectionAscending;
      } else {
        this.currentSortDirectionAscending = true;
      }
      this.currentSortColumn = newSortColumn;
    },
    confirm(email) {
      const updateConfirmedEmailDto = {
        emailAddress: email.emailAddress,
        confirmer: 'admin', //TODO Fetch name of current user
        isConfirmed: true,
        confirmationDateTime: new Date()
      };
      this.setSelectedConfirmedEmail(email);
      this.updateConfirmedEmail(updateConfirmedEmailDto);
    },
    filteredEmails() {
      if (this.emailFiltering === FilterModes.CONFIRMED) {
        return this.confirmedEmails.filter(email => email.confirmed === true);
      } else if (this.emailFiltering === FilterModes.NOT_CONFIRMED) {
        return this.confirmedEmails.filter(email => email.confirmed === false);
      }
      return this.confirmedEmails;
    },
  },
};
</script>

<style scoped>
tbody tr {
  cursor: pointer;
}

tbody tr:hover {
  background-color: aliceblue;
}

td {
  vertical-align: middle;
}

.overviewAndNav {
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}
</style>